module.exports = __webpack_public_path__ + "img/SWP_Axe_1H_05.62b93163.png";